module.exports = "/images/ny-life1-10.jpg";